/**
 * @flow
 * @relayHash a12f62d4f02fbc39ab2b357be05a0f9b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteProjectPhaseMutationVariables = {|
  id: string
|};
export type DeleteProjectPhaseMutationResponse = {|
  +deleteProjectPhase: {|
    +id: string
  |}
|};
export type DeleteProjectPhaseMutation = {|
  variables: DeleteProjectPhaseMutationVariables,
  response: DeleteProjectPhaseMutationResponse,
|};
*/


/*
mutation DeleteProjectPhaseMutation(
  $id: String!
) {
  deleteProjectPhase(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteProjectPhase",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ProjectPhaseModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteProjectPhaseMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteProjectPhaseMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteProjectPhaseMutation",
    "id": null,
    "text": "mutation DeleteProjectPhaseMutation(\n  $id: String!\n) {\n  deleteProjectPhase(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c6116fb924d1987cdc1aa7c77af100ee';
module.exports = node;
